import { useCookies } from 'react-cookie';
import { useHistory } from 'react-router-dom';

export const useCookieRedirect = (wantedStudyId: string) => {
    const [cookies, setCookie] = useCookies(['WpCurrentStudy']);
    const history = useHistory();

    if (wantedStudyId !== cookies.WpCurrentStudy) {
        setCookie("WpCurrentStudy", wantedStudyId, { path: "/", expires: new Date(9999, 12, 31) });
        history.go(0);
    }
}
